import HelpIconLink from './HelpIconLink'

export default HelpIconLink



// WEBPACK FOOTER //
// ./src/components/HelpIconLink/index.js